import React from "react";

function Article(props) {
  return (

    <div className="card" width="300px">
              <a href={"http://"+window.location.host+"/Resume/images/collection/"+props.image} target="blank">

      <div className="card-header">
          <p className="card-header-title">{props.title}</p>
      </div>
      <div className="card-image">
        <figure className="image">
          <img width="500" height="200" src={"images/collection/"+props.image} alt="" />
        </figure>
      </div>

      </a>
    </div>
  );
}

export default Article;
